/**
 * Создает стафф карточку.
 */
export function create(element, options) {
    const { StaffCard, StaffLiteCard } = window;
    const { login, uid, from, theme, status = true, fields = true, gaps = true, current = true, buttons = true, extras } = options;
    if (StaffCard) {
        return new StaffCard(element, login, {
            theme,
            status: status ? 'on' : 'off',
            fields: fields ? 'on' : 'off',
            gaps: gaps ? 'on' : 'off',
            current: current ? 'on' : 'off',
            buttons: buttons ? 'on' : 'off',
            extras: extras ? { fields: extras } : undefined
        });
    }
    if (!uid || !from) {
        throw new Error('useStaffCard: поля "uid" и "from" обязательны для работы в B2B');
    }
    if (StaffLiteCard) {
        return new StaffLiteCard({
            elem: element,
            login,
            uid,
            from
        });
    }
    throw new Error('useStaffCard: скрипт карточки не загружен');
}
